/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */
import { customFetch } from '../../mutator/custom-fetch';

export type livenessCheckResponse200 = {
  data: void
  status: 200
}

export type livenessCheckResponseSuccess = (livenessCheckResponse200) & {
  headers: Headers;
};
;

export type livenessCheckResponse = (livenessCheckResponseSuccess)

export const getLivenessCheckUrl = () => {


  

  return `/health/live`
}

export const livenessCheck = async ( options?: RequestInit): Promise<livenessCheckResponse> => {
  
  return customFetch<livenessCheckResponse>(getLivenessCheckUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

export type readinessCheckResponse200 = {
  data: void
  status: 200
}

export type readinessCheckResponse503 = {
  data: void
  status: 503
}

export type readinessCheckResponseSuccess = (readinessCheckResponse200) & {
  headers: Headers;
};
export type readinessCheckResponseError = (readinessCheckResponse503) & {
  headers: Headers;
};

export type readinessCheckResponse = (readinessCheckResponseSuccess | readinessCheckResponseError)

export const getReadinessCheckUrl = () => {


  

  return `/health/ready`
}

export const readinessCheck = async ( options?: RequestInit): Promise<readinessCheckResponse> => {
  
  return customFetch<readinessCheckResponse>(getReadinessCheckUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

export type healthCheckResponse200 = {
  data: void
  status: 200
}

export type healthCheckResponse503 = {
  data: void
  status: 503
}

export type healthCheckResponseSuccess = (healthCheckResponse200) & {
  headers: Headers;
};
export type healthCheckResponseError = (healthCheckResponse503) & {
  headers: Headers;
};

export type healthCheckResponse = (healthCheckResponseSuccess | healthCheckResponseError)

export const getHealthCheckUrl = () => {


  

  return `/health`
}

export const healthCheck = async ( options?: RequestInit): Promise<healthCheckResponse> => {
  
  return customFetch<healthCheckResponse>(getHealthCheckUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

